/**
 * MFA API slice (TOTP enrollment + disable).
 * Leaf module (Perf 3.1.b/e Step 6). Pulls only the shared chokepoint from
 * ./client; never imports a sibling @/lib/api slice.
 */
import { fetchWithAuth, ApiError } from './client';

export const mfaApi = {
  // Start TOTP enrollment (password-auth required)
  startTotpEnrollment: async (password) => {
    const data = await fetchWithAuth('/json/mfa/totp/enroll/start', {
      method: 'POST',
      body: password ? { password } : {}
    });

    if (data.error) {
      throw new ApiError(data.message || 'Failed to start MFA enrollment', 400, data);
    }

    return data; // contains { otpauthUrl, qrCodeDataUrl }
  },

  // Verify TOTP to complete enrollment (password-auth required)
  verifyTotpEnrollment: async (token) => {
    const data = await fetchWithAuth('/json/mfa/totp/enroll/verify', {
      method: 'POST',
      body: { token }
    });

    if (data.error) {
      throw new ApiError(data.message || 'Failed to verify MFA enrollment', 400, data);
    }

    return data; // may contain { backupCodes }
  },

  // Disable MFA (password-auth required)
  disableMfa: async (password) => {
    const data = await fetchWithAuth('/json/mfa/disable', {
      method: 'POST',
      body: password ? { password } : {}
    });

    if (data.error) {
      throw new ApiError(data.message || 'Failed to disable MFA', 400, data);
    }

    return data;
  },
};
